import { Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import React from 'react';

const useStyles = makeStyles(theme => ({
    base: {
        padding: `${theme.spacing(.25)} ${theme.spacing(.5)}`,
        borderRadius: "2em",
        textAlign: 'center',

        textTransform: 'uppercase',
        color: "#fff",
    },
    label: {
        // push the text down so it looks centered (because the text is uppercase)
        marginTop: ".07em",
        marginBottom: "-.07em",
    },
    rating: {
        //maxWidth: "40px",
        display: 'inline-block',
        padding: '2px 10px'
    },
    ratingPG: {
        color: '#121212',
        backgroundColor:'#deb650'
    },
    ratingU: {
        backgroundColor:'#00c0b5',
    },
    rating12A: {
        backgroundColor:'#B36901',
    },
    rating15: {
        backgroundColor:'#A85D6A',
    },
    rating18: {
        backgroundColor:'#83182A',
    },
    ratingR18: {
        backgroundColor:'#174496',
    },
    flag: {
        border: "0.75px solid rgba(255, 255, 255, 0.7)",
        // we need to remove the size of the border from the padding so that we are the same size as other chips
        padding: `calc(${theme.spacing(.25)} - 1px) calc(${theme.spacing(1.2)} - 1px)`,
        color: theme.palette.secondary.contrastText,
        backgroundColor: '#121212',
        //maxWidth: '40px',
        display: 'inline-block',
    },
    mandatory: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },

}));

export default function FlagButton({ className = "", variant, label = null, ...props }) {
    const classes = useStyles();

    const variants = {
        "default": {
            label: "Not yet rated",
            className: classes.flag,
        },

        "u": {
            label: "U",
            className: classes.rating + " " + classes.ratingU,
        },
        "pg": {
            label: "PG",
            className: classes.rating + " " + classes.ratingPG,
        },
        "12": {
            label: "12",
            className: classes.rating + " " + classes.rating12A,
        },
        "15": {
            label: "15",
            className: classes.rating + " " + classes.rating15,
        },
        "12a": {
            label: "12A",
            className: classes.rating + " " + classes.rating12A,
        },
        "18": {
            label: "18",
            className: classes.rating + " " + classes.rating18,
        },
        "r18": {
            label: "R18",
            className: classes.rating + " " + classes.ratingR18,
        },
        "mandatory": {
            label: "Viewing Group",
            className: classes.flag + " " + classes.mandatory,
        },
        "cc": {
            label: "CC",
            className: classes.flag,
        },
        "ad": {
            label: "AD",
            className: classes.flag,
        },
    };
    
    const variantConfig = variants[variant && variant.toLowerCase()] ?? variants["default"];

    const displayLabel = label ?? variantConfig.label;
    const displayClassName = className + " " + classes.base + " " + variantConfig.className;

    return (
        <div className={displayClassName} {...props}>
            <Typography variant="body2" className={classes.label}>{displayLabel}</Typography>
        </div>
    );
}